var map = {
	"./deprecation.plugin.js": "5y4X",
	"./device-helper.plugin.js": "Da/R",
	"./meta-info.plugin.js": "k/0T",
	"./sanitize.plugin.js": "q8FM",
	"./shortcut.plugin.js": "+hrt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gTrl";